import React from 'react';

import { List, Datagrid, TextField, Pagination } from 'react-admin';

import { ScrollingWrapper } from '../../../components/ScrollingWrapper';
import { DateTimeField } from '../../../components/fields/DateFormatField';

import { LoginLogsFilter } from './ListFilters';

import { YesNoField } from 'components/fields/YesNoField';


const defaultSort = { field: 'created_at', order: 'DESC' };


export const LoginLogsList = props => {


	return (
		<List
			{...props}
			sort={defaultSort}
			exporter={false}
			pagination={<Pagination rowsPerPageOptions={[100, 200, 500]} />}
			bulkActionButtons={false}
			filters={<LoginLogsFilter />}
		>
			<ScrollingWrapper>
				<Datagrid
					rowClick='show'
					rowStyle={(record, index) => {
						return {
							height: '48px',
						};
					}}
				>
					<TextField source='user_id' sortable={false}/>
					<TextField source='user_role' sortable={false}/>
					<YesNoField source='logged_via_code'/>
					<TextField source='email' sortable={false}/>
					<TextField source='ip_address' sortable={false}/>
					<TextField source='user_agent' sortable={false}/>
					<TextField source='location' sortable={false}/>
					<DateTimeField source='created_at' label="Logged at"/>
				</Datagrid>
			</ScrollingWrapper>
		</List>
	);
};
